var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.0211,
    cy: 18.0736,
    r: 17.3053,
    fill: "#000E4B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6736 16.7272L23.519 13.5276L13.8749 23.1716L17.0746 26.3262H9.36831V18.62L12.5229 21.8197L22.167 12.1756L18.9673 9.02098H26.6736V16.7272Z",
    fill: "#FAFAFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.e82720be28948167fc73e9e5b4afa454.svg";
export { ForwardRef as ReactComponent };